import Vue from "vue"
import VueRouter from "vue-router"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import vuetify from "./plugins/vuetify"
import "./vee-validate"
import Dayjs from "dayjs"

Date.prototype.addHours = function (h) {
  this.setTime(this.getTime() + h * 60 * 60 * 1000)
  return this
}

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(Dayjs)
new Vue({
  router,
  store,
  vuetify,
  render: function (h) {
    return h(App)
  },
}).$mount("#app")
